var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommitment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67.296,
    height: 42.428,
    viewBox: "0 0 67.296 42.428",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_62779",
    "data-name": "Group 62779",
    transform: "translate(1 1.194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107812",
    "data-name": "Path 107812",
    d: "M110.011,132.691s9.672-4,14.512-5.951a16.859,16.859,0,0,1,15.066,1.487c4.187,2.791,10.6,5.208,13.954,4.373",
    transform: "translate(-98.57 -125.614)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107813",
    "data-name": "Path 107813",
    d: "M120.76,126.084s-9.743,8.182-9.676,10.6c.095,3.254,8.185,7.161,16.746-3.255l19.111,22.183",
    transform: "translate(-96.017 -124.496)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107814",
    "data-name": "Path 107814",
    d: "M109.887,134.557a75.246,75.246,0,0,1,11.673,7.023c7.536,5.674,16.742,5.211,27.161-4.65,0,0,2.606-2.788,5.022-2.7",
    transform: "translate(-98.865 -105.111)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24644",
    "data-name": "Rectangle 24644",
    width: 10.79,
    height: 30.695,
    rx: 0.933,
    transform: "translate(0 3.078)",
    fill: "none",
    stroke: "#00a6ef",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24645",
    "data-name": "Rectangle 24645",
    width: 10.79,
    height: 30.695,
    rx: 0.933,
    transform: "translate(54.506 3.078)",
    fill: "none",
    stroke: "#00a6ef",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommitment);
export default __webpack_public_path__ + "static/media/commitment.95cd36b72f2261fc3aed42a6fdb4a78e.svg";
export { ForwardRef as ReactComponent };